import { Dialog, DialogBackdrop, Transition, TransitionChild } from '@headlessui/react';
import React, { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- isOpen/setIsOpen are polymorphic: callers pass Deal|null, string|false, boolean, etc.
interface ModalProps {
  isOpen?: any
  setIsOpen: (open: any) => void
  onClose?: () => void
  initialFocus?: React.RefObject<HTMLElement | null>
  children?: React.ReactNode
  wrapClasses?: string
  overflowHidden?: boolean
}

const Modal = function (props: ModalProps) {
  const {
    isOpen = false,
    setIsOpen,
    onClose,
    initialFocus,
    children,
    wrapClasses = 'sm:max-w-lg',
    overflowHidden = true
  } = props
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        // HeadlessUI generates dynamic dialog IDs, find the open dialog
        const dialog = document.querySelector('[role="dialog"]')
        if (dialog) dialog.scrollTop = 0
      }, 0);
      return () => clearTimeout(timer)
    }
  }, [isOpen]);
  return (
    <Transition show={Boolean(isOpen)}>
      <Dialog
        as="div"
        static
        className="fixed z-60 inset-0 overflow-y-auto"
        initialFocus={initialFocus}
        open={Boolean(isOpen)}
        onClose={() => { setIsOpen(false); onClose && onClose() }}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop className="fixed inset-0 bg-ink/30 transition-opacity" />
          </TransitionChild>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className={`inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl relative transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6 ${wrapClasses} ${overflowHidden ? 'overflow-hidden' : ''}`}>
              {children}
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal
